import { render, staticRenderFns } from "./ItsStockRawInBoundWarehousingDetail.vue?vue&type=template&id=32ae9b58&scoped=true&"
import script from "./ItsStockRawInBoundWarehousingDetail.vue?vue&type=script&lang=js&"
export * from "./ItsStockRawInBoundWarehousingDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsStockRawInBoundWarehousingDetail.vue?vue&type=style&index=0&id=32ae9b58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae9b58",
  null
  
)

export default component.exports